var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 130,
    viewBox: "0 0 104 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5151 19.8545H80.5599",
    stroke: "#007EBD",
    strokeWidth: 2.20469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5151 11.5224L73.4181 2",
    stroke: "#007EBD",
    strokeWidth: 2.20469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5151 28.1866L73.4181 37.709",
    stroke: "#007EBD",
    strokeWidth: 2.20469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2652 12.7129C10.9338 12.7129 -2.35654 31.2816 10.9338 26.9965C21.5661 23.5684 23.4187 30.3293 24.2242 34.1383H36.3059C36.3059 27.2821 44.3607 24.6159 48.3881 24.1398V15.5696C48.7909 15.5696 45.7304 12.7129 30.2652 12.7129Z",
    stroke: "#007EBD",
    strokeWidth: 2.20469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9441 101.176C57.1506 110.301 54.1352 128.553 48.4217 128.553C42.7083 128.553 20.648 128.553 10.3321 128.553C7.55474 125.775 2 118.316 2 110.698C2 103.08 2 96.4145 2 94.0339C2.79353 87.6856 7.71344 71.4182 21.0448 57.1346C21.0448 57.1346 21.0448 46.4218 21.0448 41.6606H38.8993V63.0861C38.8993 65.4667 39.8516 70.704 43.6605 72.6085C47.4695 74.5129 51.5959 79.7503 53.1829 82.1309",
    stroke: "#007EBD",
    strokeWidth: 2.20469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.8977,
    y: 34.8977,
    width: 15.2047,
    height: 6.20469,
    stroke: "#007EBD",
    strokeWidth: 2.20469,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1023,
    y: 15.8977,
    width: 8.20469,
    height: 4.20469,
    transform: "rotate(90 53.1023 15.8977)",
    stroke: "#007EBD",
    strokeWidth: 2.20469,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1523 78.9331C70.1523 78.9331 71.7677 84.5132 74.2741 87.0196C76.7804 89.526 82.3606 91.1413 82.3606 91.1413C82.3606 91.1413 76.7804 92.7567 74.2741 95.263C71.7677 97.7694 70.1523 103.35 70.1523 103.35C70.1523 103.35 68.537 97.7694 66.0306 95.263C63.5243 92.7567 57.9441 91.1413 57.9441 91.1413C57.9441 91.1413 63.5243 89.526 66.0306 87.0196C68.537 84.5132 70.1523 78.9331 70.1523 78.9331Z",
    stroke: "#007EBD",
    strokeWidth: 1.65352,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1646 66.5762C93.1646 66.5762 94.4761 71.1068 96.5111 73.1418C98.5461 75.1768 103.077 76.4884 103.077 76.4884C103.077 76.4884 98.5461 77.7999 96.5111 79.8349C94.4761 81.8699 93.1646 86.4006 93.1646 86.4006C93.1646 86.4006 91.853 81.8699 89.818 79.8349C87.783 77.7999 83.2523 76.4884 83.2523 76.4884C83.2523 76.4884 87.783 75.1768 89.818 73.1418C91.853 71.1068 93.1646 66.5762 93.1646 66.5762Z",
    stroke: "#007EBD",
    strokeWidth: 1.65352,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1353 53.0903C74.1353 53.0903 75.1755 56.6837 76.7895 58.2977C78.4035 59.9117 81.9969 60.952 81.9969 60.952C81.9969 60.952 78.4035 61.9922 76.7895 63.6062C75.1755 65.2202 74.1353 68.8136 74.1353 68.8136C74.1353 68.8136 73.095 65.2202 71.481 63.6062C69.867 61.9922 66.2736 60.952 66.2736 60.952C66.2736 60.952 69.867 59.9117 71.481 58.2977C73.095 56.6837 74.1353 53.0903 74.1353 53.0903Z",
    stroke: "#007EBD",
    strokeWidth: 1.65352,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardIcon);
export default __webpack_public_path__ + "static/media/standardIcon.9d3efb21e6151b0e7621330a0d13d405.svg";
export { ForwardRef as ReactComponent };